export default {
    contactTitle:
        "<p>\u00c4r du p\u00e5 jakt efter en sm\u00e5tt fantastisk digitalbyr\u00e5? Jessica Kardemark vill g\u00e4rna tr\u00e4ffa dig is\u00e5fall. Ring henne p\u00e5 076-168 44 50 eller maila <a href='mailto:jessica@frojd.se'>jessica@frojd.se</a></p>",
    address:
        "<p>Fr\u00f6jd Interactive</p><p><a href='https://www.google.se/maps/place/Fr%C3%B6jd+Interactive+AB/@59.3423872,18.0589883,17z/data=!3m1!4b1!4m5!3m4!1s0x465f9d665505d197:0x3391ccfb2113c427!8m2!3d59.3423845!4d18.061177'>Kungstensgatan 18</a></p><p>113 57 Stockholm</p>",
};
